import { render, staticRenderFns } from "./FrequencyDisplay.vue?vue&type=template&id=24cb3630&"
import script from "./FrequencyDisplay.vue?vue&type=script&lang=js&"
export * from "./FrequencyDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports